export default "__VITE_ASSET__Dw0b00VC__"